import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

const fallbackLanguage = 'en';
const NUMBER_OF_LETTERS_TO_ABBREVIATE_LANGUAGE = 2;
export const formatLanguage = (lng: string) =>
  lng.slice(0, NUMBER_OF_LETTERS_TO_ABBREVIATE_LANGUAGE).toLowerCase() +
  lng.slice(NUMBER_OF_LETTERS_TO_ABBREVIATE_LANGUAGE);

const fileExists = (fileName: string) => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    require(`../../languages/${fileName}.json`);
    return true;
  } catch {
    return false;
  }
};

i18n.use(initReactI18next);

export const i18nInit = async (language: string) => {
  const languageFileName = formatLanguage(language.replace('-', '_'));

  const resources = {
    [fallbackLanguage]: {
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      translation: await require(`../../languages/${fallbackLanguage}.json`),
    },
  };
  if (fileExists(languageFileName) && language !== fallbackLanguage) {
    resources[language] = {
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      translation: await require(`../../languages/${languageFileName}.json`),
    };
  }

  await i18n.init({
    resources,
    lng: language,
    load: 'currentOnly',
    fallbackLng: fallbackLanguage,
    interpolation: {
      escapeValue: false,
    },
  });
};

export default i18n;
